import type { DomainOverviewData } from './split-view.interface'

export const mockDomainOverviewData: DomainOverviewData = {
  domain: 'example.com',
  registeredAt: '2010-03-15T00:00:00Z',
  expiresAt: '2027-03-15T00:00:00Z',
  registrar: 'Cloudflare, Inc.',
  nameServerList: ['ns1.cloudflare.com', 'ns2.cloudflare.com'],
  ipAddress: '93.184.216.34',
  hosting: 'Cloudflare',
  sslIssuer: "Let's Encrypt",
  sslExpiresAt: '2025-06-15T00:00:00Z',
  metricList: [
    { label: 'Domain Authority', value: 92, trend: 'up', change: '+2' },
    { label: 'Monthly Traffic', value: '2.4M', trend: 'up', change: '+15%' },
    { label: 'Backlinks', value: '45.2K', trend: 'neutral', change: '0%' },
    { label: 'Page Speed', value: '94/100', trend: 'up', change: '+5' },
    { label: 'Spam Score', value: '1%', trend: 'down', change: '-1%' },
    { label: 'Trust Score', value: 'High', trend: 'neutral' },
  ],
  technologyList: [
    { name: 'React', category: 'Frontend', confidence: 95 },
    { name: 'Next.js', category: 'Framework', confidence: 90 },
    { name: 'Tailwind CSS', category: 'Styling', confidence: 98 },
    { name: 'Cloudflare', category: 'CDN', confidence: 100 },
    { name: 'Node.js', category: 'Backend', confidence: 85 },
    { name: 'PostgreSQL', category: 'Database', confidence: 70 },
  ],
  seo: {
    title: 'Example Domain - The Official Example Website',
    description:
      'This domain is for use in illustrative examples in documents. You may use this domain in literature without prior coordination or asking for permission.',
    keywords: ['example', 'domain', 'documentation', 'sample', 'test'],
    score: 87,
  },
}
